import { Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, intro, children }) => (
  <section className="shell pt-40 lg:pt-52 pb-16 lg:pb-24">
    <Reveal><span className="eyebrow">{eyebrow}</span></Reveal>
    <Reveal delay={0.08}>
      <h1 className="display mt-6 text-[#f5f3ee] text-4xl sm:text-6xl lg:text-7xl max-w-5xl">{title}</h1>
    </Reveal>
    {intro && (
      <Reveal delay={0.16} className="mt-10 max-w-2xl">
        <p className="text-[#a7a7a2] text-lg sm:text-xl leading-relaxed">{intro}</p>
      </Reveal>
    )}
    {children}
  </section>
);

export default PageHero;
